export const patientWelcomeText =
  "our mission is to increase access to high-quality, nuanced, and personalized mental healthcare by building tools that accelerate the human connection essential for meaningful care.";

export const PRONOUNS = {
  he: "he/him/his",
  she: "she/her/hers",
  they: "they/them/theirs",
  other: "other",
} as const;

export const SCRIPT_LIFE = {
  current: "current",
  past: "past",
  all: "all",
} as const;

export const COMMENT_TITLE = {
  OPENED_BY_PATIENT: "Prescription Request opened by patient",
  CANCELED_BY_PATIENT: "Prescription Request canceled by patient",
  REOPENED_BY_PATIENT: "Prescription Request re-opened by patient",
} as const;

export const DATA_TOKEN = "data-token" as const;

export const PATIENT_SIGN_UP_MIN_AGE = 13;
export const PATIENT_SIGN_UP_ADULT_AGE = 18;
